module.exports = __webpack_public_path__ + "img/21-indian.4789b0db.svg";